import { createContext } from 'react';

import { DEFAULT_MAX_RANGE_VALUE } from '../constants.js';

export const GaugeChartRangeMaxContext = createContext<number>(
  DEFAULT_MAX_RANGE_VALUE,
);
